
import DeprecatedPlugin from './deprecated-plugin-interface/index.js';

export default DeprecatedPlugin;

export * from './mixin-interface/index.js';
